import styled, { css } from 'styled-components';
import Typography from '../typography/typography';

export const TRUNCATED_LENGTH = 30;

export const TitleWrapper = styled.div`
  margin-top: 3px;
`;

export const DocumentDescription = styled(Typography)`
  overflow-wrap: anywhere;
`;

export const ActionsContainer = styled.div`
  ${({ theme }) => css`
    height: 100%;
    display: flex;
    gap: ${theme.spacing(2)};
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-start;
    margin-left: auto;
  `}
`;

export const DocumentContainer = styled.div`
  ${({ theme }) => css`
    margin-right: ${theme.spacing(0.5)};
    margin-top: ${theme.spacing(0.25)};
    line-height: 16px;
  `}
`;

export const TitleAndDescriptionContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${theme.spacing(1)};
    text-align: left;
  `}
`;
